// extracted by css-extract-rspack-plugin
export default {"Body":"ArtifactPanelContent-module__Body__iFTeJ","PlainBody":"ArtifactPanelContent-module__PlainBody__JKcRC"};